import styled from "styled-components";
import { margin } from "styled-system";

export const StyledContainer = styled.div`
  ${margin}
`;
